// Colores de superficie usados en las ondas que separan secciones.
export const surface = {
  white: "#FFFFFF",
  mist: "#F5F7F8",
  navy: "#0D2A47",
  violet: "#514273",
};
